<div class="landing-container">

  <section class="landing-section painted">
    <div class="hero-div">
      <div class="hero-content">
        <img src="/assets/logo_light@2x.png" alt="Traccio" style="max-width: 300px;">
        <h3>Say goodbye to dull text files and spreadsheets, track your job search the right way.</h3>
        <div class="spanning-content">
          <a class="header-btn" routerLink="/signup" style="margin-left: 0;">Join now</a>
          <a class="header-btn alt" routerLink="/about">Learn more</a>
        </div>
      </div>
      <img src="https://res.cloudinary.com/djxztokzp/image/upload/v1607788756/Traccio_Assets/hero_graphic_omxhqs.svg" role="presentation" alt="" class="hero-img">
    </div>
  </section>

  <div class="sticky-header-bg"></div>

  <section class="landing-section">
    <div class="landing-div">
      <img src="https://res.cloudinary.com/djxztokzp/image/upload/v1607466965/Traccio_Assets/traccio_main_yz4gv3.svg" class="screenshot" alt="Screenshot of Traccio's Dashboard on desktop and mobile browser windows">
      <p>Traccio is an organizational tool that helps you keep track of your job applications. <br>It allows you to efficiently monitor and analyze your job hunts, and helps you remain motivated!</p>
    </div>
  </section>

  <section class="landing-section painted">
    <div class="landing-div alt call-to-action">
      <h3>Make your job hunt just a little more bearable! ✨</h3>
      <p>Log your applications, and let Traccio do the rest.</p>
    </div>
  </section>

  <section class="landing-section">
    <div class="landing-div">
      <img src="/assets/landing-graphics/Dashboard1.svg" alt="Abstracted graphic of a graph displaying application frequencies over the past week">
      <div>
        <p class="heading">Visualize your job search</p>
        <p>Keep an eye on your productivity, and monitor your application frequency and different trends in your job search</p>
      </div>
    </div>
    <div class="landing-div reverse">
      <img src="/assets/landing-graphics/Journeys.svg" alt="Abstracted graphic of a collection of three Traccio Journeys">
      <div>
        <p class="heading">Stay organized</p>
        <p>Organize your job hunts using Journeys, break them up however you like, and visualize your progress a little better</p>
      </div>
    </div>
    <div class="landing-div">
      <img src="/assets/landing-graphics/AppDetails.svg" alt="Abstracted graphic of application details, including a visual status timeline with four chronological status indicators ending with a final status of 'Offer' and that status's date">
      <div>
        <p class="heading">Track your applications</p>
        <p>Log and update applications you submitted, and keep all your records in one place</p>
      </div>
    </div>
    <div class="landing-div reverse">
      <img src="/assets/landing-graphics/Search.svg" alt="Abstracted graphic of a list of search results, showing the search term 'Hooli' and its corresponding Journey and Application search results">
      <div>
        <p class="heading">Duplicate applications who?</p>
        <p>Filter your submitted applications, and say goodbye to submitting the same application twice (or 7 times)!</p>
      </div>
    </div>
  </section>

  <section class="landing-section painted">
    <div class="landing-div call-to-action">
      <h2>Ready to give Traccio a try?</h2>
      <div class="flex-row">
        <a class="header-btn" routerLink="/signup">Join now</a>
        <a class="header-btn alt" routerLink="/demo/home">Try demo</a>
      </div>
    </div>
  </section>
</div>
<scroll-button></scroll-button>
